import { Injectable } from '@angular/core';
import { AbstractGraphqlRequest, GraphqlRequestType } from '@ckmk/angular';
import { PostFetchAllPayload } from '@app/src/app/modules/post/types/types';
import { TypedDocumentNode } from '@apollo/client';
import { PostModel } from '@app/src/app/modules/post/classes/default/model/post.model';
import { gql } from 'apollo-angular';

@Injectable({
  providedIn: 'root',
})
export class PostsPublicRequestQuery extends AbstractGraphqlRequest<
  PostModel[],
  { payload: PostFetchAllPayload }
> {
  protected override type: GraphqlRequestType = 'query';

  protected override getQuery(): TypedDocumentNode<any, any> {
    return gql`
      query findPublicPosts($payload: PostRequestPayloadInput) {
        findPublicPosts(payload: $payload) {
          category {
            title
            description
            slug
          }
          picture {
            name
            extension
            directory
            directories
            frontUrls
            mimetype
          }
          slug
          title
          shortDescription
          active
          updatedAt
          updatedBy
        }
      }
    `;
  }

  protected override onParseResult(data: any, payload?: any) {
    const result = data.findPublicPosts || [];

    return result.map((grp: any) => new PostModel(grp));
  }
}
